// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignInForm_submitBtnContainer {
  margin-top: 8px;
}
.SignInForm_button {
  border-radius: 8px;
  text-transform: none;
}
`, "",{"version":3,"sources":["webpack://./views/forms/SignInForm/SignInForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".SignInForm_submitBtnContainer {\n  margin-top: 8px;\n}\n.SignInForm_button {\n  border-radius: 8px;\n  text-transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
